import { t, kieli } from "./kieli";
import { tunnistaPuuteKuvaus } from "./puutekuvaus";

/** Puutteen kuvaus lukijan kielellä (Toni 18.10.2026 klo 13.55, vaihtoehto A; ks. puutekuvaus.ts). Suomeksi kannan teksti
 *  sellaisenaan. Muilla kielillä tunnistettu säännön kuvaus käännösavaimella; tunnistamaton (tuotu tai käsin kirjattu)
 *  teksti näytetään sellaisenaan, koska se on kirjoittajan omaa tekstiä. */
export function puuteKuvausTeksti(kuvaus: string | null | undefined): string {
  if (!kuvaus) return "";
  if (kieli() === "fi") return kuvaus;
  const osuma = tunnistaPuuteKuvaus(kuvaus);
  if (!osuma) return kuvaus;
  const p = { ...osuma.parametrit };
  // Havaintosääntö kirjoittaa tyhjän lähdearvon sanana «(tyhjä)»; se on käyttöliittymätekstiä, ei dataa.
  if (p.raaka === "(tyhjä)") p.raaka = t("puute.k.tyhja");
  // Painekoe- ja IV-säännöt (190) kirjoittavat puuttuvan päivän ja kalibroinnin sanoina.
  if (p.pvm === "päivä puuttuu") p.pvm = t("puute.k.paiva_puuttuu");
  if (p.asti === "ei kalibrointia") p.asti = t("puute.k.ei_kalibrointia");
  return t(osuma.saanto.avain, p);
}
